/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { escapeReturnUrl } from 'util/url';
import HeaderLink from './header-link';
import HeaderLogo from './header-logo';
import styles from './header.less';

interface StaticHeaderProps {
  isLoggedIn: boolean;
  color?: string;
}

// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
const format = forTemplate('header_signup_login');
const formatDirectory = forTemplate('directory');

const AnonymousButtons = () => {
  const returnUrl = escapeReturnUrl(location.href);

  return (
    <React.Fragment>
      <HeaderLink
        href={`/signup?returnUrl=${returnUrl}`}
        buttonStyle="signUpColor"
        preventDefault={false}
      >
        <span className={styles.buttonText}>{format('sign-up')}</span>
      </HeaderLink>
      <HeaderLink
        href={`/login?returnUrl=${returnUrl}`}
        buttonStyle="normalColor"
        preventDefault={false}
      >
        <span className={styles.buttonText}>{format('log-in')}</span>
      </HeaderLink>
    </React.Fragment>
  );
};

const AuthenticatedButton = () => (
  <HeaderLink href="/" buttonStyle="normalColor" preventDefault={false}>
    <span className={styles.buttonText}>
      {formatDirectory('go-to-your-boards')}
    </span>
  </HeaderLink>
);

const StaticHeader: React.FunctionComponent<StaticHeaderProps> = ({
  isLoggedIn,
  color,
}) => {
  const headerClassNames = classNames(
    styles.default,
    styles.static,
    styles.header,
    {
      [styles.businessBlue]: color === 'business-blue',
      [styles.powerUpsPurple]: color === 'power-ups-purple',
    },
  );

  return (
    <div
      id="header"
      className={headerClassNames}
      data-test-id={HeaderTestIds.Container}
    >
      <div className={styles.leftSection}>
        <HeaderLogo
          className={styles.staticHeaderLogo}
          preventDefault={false}
        />
      </div>

      <div className={styles.rightSection}>
        {isLoggedIn ? <AuthenticatedButton /> : <AnonymousButtons />}
      </div>
    </div>
  );
};

export default StaticHeader;



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/static-header.tsx